module.exports = __webpack_public_path__ + "static/media/link-icon.d0238457.svg";